import React from "react";
import { useRecoilState } from "recoil";
import { Flex, Image } from "rebass/styled-components";

import {
  CreateSignatureCardWrapper,
  StyledSubheader,
} from "./styledComponents";
import { StyledHeadline } from "../../../styledComponents";
import { Divider } from "../../../../../Components/Divider";
import { AllstarModalState } from "../../../../../State/modals";
import { ModalType } from "../../../../../@types";
import theme from "../../../../../../theme/themeThree";
import { StudioSession } from "../../../../../State/studioSession";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;
export const CreateSignature = () => {
  const [, setAllstarModalState] = useRecoilState(AllstarModalState);
  const [studioSession] = useRecoilState(StudioSession);
  return (
    <CreateSignatureCardWrapper
      onClick={() => {
        window.rudderanalytics.track("Signature - Open Modal", {
          where: !studioSession.isRemixSession ? "Studio" : "Remix",
          type: "Create",
        });
        setAllstarModalState({
          isOpen: ModalType.SignatureSelector,
          functions: {},
          data: {},
        });
      }}
    >
      <StyledHeadline>Brand your clips!</StyledHeadline>
      <Divider
        width="100%"
        style={{ backgroundColor: theme.colors.turboAlpha50, height: 1 }}
      />

      <Flex style={{ gap: 10 }} alignItems={"center"}>
        <Image
          src={`${REACT_APP_S3_CLIP_BUCKET}/static/loadouts/sig.svg`}
          height={25}
          width={25}
        />
        <StyledSubheader className="create-signature-hover">
          Set My Signature
        </StyledSubheader>
      </Flex>
    </CreateSignatureCardWrapper>
  );
};
